import { ListOutlined, MoreVertOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import { font } from "../../../styles/font";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import ViewListOutlined from "@mui/icons-material/ViewListOutlined";
import { ModulePath } from "../../../constant/ApplicationVariables";
import { LightTooltip } from "../../styled/CustomComponent";
import { ProjectCustomIcon } from "../../styled/CustomIcons";
import { useLocation, useNavigate } from "react-router-dom";
import { useApplicationContext } from "../../../context/ApplicationContext";
import { memo } from "react";

function ActiveProjectCard() {
  const { activeProject, currentFolderData, toggleFolderSidebar } =
    useApplicationContext();
  const { activeConfiguration, setActiveConfiguration } =
    useApplicationContext();
  const theme = useTheme();
  const navigate = useNavigate();
  const pathName = useLocation()?.pathname;

  // Retaining placeholder state and handlers for context consistency,
  // although the icons themselves are now in ApplicationSidebar.jsx
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

  const handleToggleMoreMenu = (event) => {
    if (moreMenuAnchorEl) {
      setMoreMenuAnchorEl(null);
    } else {
      setMoreMenuAnchorEl(event.currentTarget);
    }
  };

  const handleClickMoreItem = (itemValue) => {
    setActiveConfiguration({ label: itemValue, value: itemValue });
    setMoreMenuAnchorEl(null);
    navigate(ModulePath.configuration);
  };

  console.log(activeProject, "activeProject");

  return (
    <Box className="flex items-center gap-0 w-full h-full overflow-hidden">
      {/* COLLAPSED VIEW */}
      {!toggleFolderSidebar ? (
        <Box className="flex items-center gap-0 w-full h-full ">
          <LightTooltip title={activeProject?.name} placement="right" arrow>
            <Avatar
              variant="rounded"
              className="
    bg-primary
    text-primary-foreground  
  "
            >
              <Typography
                fontSize={font.size.fs_4}
                fontWeight={600}
                color="inherit"
                className="uppercase text-inherit"
              >
                {activeProject?.name[0]}
              </Typography>
            </Avatar>
          </LightTooltip>
        </Box>
      ) : (
        /* EXPANDED VIEW: ONLY STRUCTURAL BOXES REMAIN */
        <Box className="flex items-center gap-0 w-full h-full overflow-hidden p-2">
          {/* 
                    <Box className="flex-1 h-full flex items-center gap-2 overflow-hidden">
                        <Avatar variant="rounded" sx={{ background: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}>
                            <ProjectCustomIcon sx={{ fontSize: font.size.fs_2, color: "inherit" }} />
                        </Avatar>


                        <Box className=" flex flex-col justify-between flex-1 w-auto gap-1 overflow-hidden" >
                            <LightTooltip
                                title={activeProject?.name}
                                placement="right"
                                arrow
                            >
                                <Typography fontWeight={600} sx={{ color: theme.palette.text.primary }} className="line-clamp-1">{activeProject?.name}</Typography>
                            </LightTooltip>
                            
                            <LightTooltip
                                title={activeProject?.description}
                                placement="right"
                            >
                                <Typography lineHeight={font.size.fs_5} className="flex-1 line-clamp-1" sx={{ color: theme.palette.text.secondary }}>{activeProject?.description}</Typography>
                            </LightTooltip>
                        </Box>

                    </Box> 
                    // ---------------------------------------------------------------------------------------------------
                    */}
        </Box>
      )}
    </Box>
  );
}

export default memo(ActiveProjectCard);
